module.exports = __webpack_public_path__ + "static/Apercu-Regular-cae6fe87fa913c00b14b2d4c8df17be0.svg";